export default "__VITE_PUBLIC_ASSET__3aec3f28__"